// 分店履约的实物商品由所属分店处理；平台版型打印发货保留原流程。
export function platformSaleReadOnly(order:any,operator:any):boolean {
 return Number(operator?.orgId)===1000 && [3,4,8,9,10,11].includes(Number(order?.orderType)) && (order?.fulfillmentOrgId==null || Number(order.fulfillmentOrgId)>1000)
}
